import { useState } from 'react';
import { ActividadesContext } from '../Contexts';

export function ActividadesProvider({ children }) {
    const [fuenteContext, setFuente] = useState(0);
    const [referenciaContext, setReferencia] = useState(0);
    const [onContextRefresh, refrescarActividades] = useState();
    const [esViewContext] = useState(true);

    return (
        <ActividadesContext.Provider
            value={{
                fuenteContext,
                referenciaContext,
                esViewContext,
                refrescarActividades,
                setFuente,
                onContextRefresh,
                setReferencia,
            }}
        >
            {children}
        </ActividadesContext.Provider>
    );
}
